
export * from '../../frontend-taglib-clay/__liferay__/exports/@clayui$modal.js';

import __default__ from '../../frontend-taglib-clay/__liferay__/exports/@clayui$modal.js';
export default __default__;
